import { MaxBrainAudience } from './audience.model';

export class AudienceMoveToCommand {
    parent: { id: string };

    constructor(target: MaxBrainAudience) {
        this.parent = { id: target.id };
    }
}
